module.exports = __webpack_public_path__ + "static/media/left-arrow-white.ec525e1a.svg";